var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/ship"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ship"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0168 10.3081C17.7418 10.5997 18.1918 11.4581 18.0251 12.2164L17.6834 13.7664C17.0918 16.4331 15.0001 18.3331 11.9834 18.3331H8.01677C5.00011 18.3331 2.90844 16.4331 2.31678 13.7664L1.97511 12.2164C1.80844 11.4581 2.25843 10.5997 2.98343 10.3081L4.16678 9.83307L8.75845 7.99141C9.55845 7.67474 10.4418 7.67474 11.2418 7.99141L15.8334 9.83307L17.0168 10.3081Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 18.334V8.33398",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8337 6.66602V9.83267L11.242 7.99101C10.442 7.67435 9.55867 7.67435 8.75867 7.99101L4.16699 9.83267V6.66602C4.16699 5.29102 5.29199 4.16602 6.66699 4.16602H13.3337C14.7087 4.16602 15.8337 5.29102 15.8337 6.66602Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.0837 4.16602H7.91699V2.49935C7.91699 2.04102 8.29199 1.66602 8.75033 1.66602H11.2503C11.7087 1.66602 12.0837 2.04102 12.0837 2.49935V4.16602Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.982bd77db2d6878b11be64bf40605cfe.svg";
export { ForwardRef as ReactComponent };